import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import { Spring } from "react-spring/renderprops";
import reactImage from "../assets/react.png";
import JS from "../assets/js.png";
import node from "../assets/nodejs.png";
import ts from "../assets/ts.png";
import nextImg from "../assets/next.jpeg";
import tailwind from "../assets/tailwind.png"

const Summary = () => {
  return (
    <div
      style={{
        background: "linear-gradient(101.25deg, #001957 8.28%, #001342 96.69%)",
      }}
      className="w-full h-100 fontR text-white"
      id="Stack"
    >
      <VisibilitySensor partialVisibility>
        {({ isVisible }) => (
          <Spring
            delay={100}
            to={{
              transform: isVisible ? "translateY(0)" : "translateY(20%)",
            }}
          >
            {(props) => (
              <div
                className="w-full lg:w-4/6 mx-auto py-28 text-center"
                style={{ ...props }}
              >
                <h1 className="text-3xl lg:text-5xl fontRB font-semibold">
                  Stack
                </h1>
                <p className="fontN my-8 text-md mx-4">
                  Over the last 3 years, I have worked on projects that span
                  across different industries
                  <br className="hidden lg:block" /> I have used the following
                  stack majorly
                </p>
                <div className="flex flex-wrap justify-evenly items-end w-full mx-auto my-16 fontN">
                  <div className="text-center bg-[grey] rounded-full w-[40px] h-[40px]">
                    {/* <h1 className="text-3xl">3+</h1>
                    <p className="text-sm">Years</p> */}
                    <img
                      src={reactImage}
                      className="w-[30px] h-[30px] m-auto"
                      width="100px"
                      height="100px"
                    />
                    <p className="text-md my-2">ReactJS</p>
                  </div>
                  <div className="text-center bg-[grey] rounded-full w-[40px] h-[40px]">
                    {/* <h1 className="text-3xl">3+</h1>
                    <p className="text-sm">Years</p> */}
                    <img
                      src={nextImg}
                      className="w-[30px] h-[30px] m-auto"
                      width="100px"
                      height="100px"
                    />
                    <p className="text-md my-2">NextJS</p>
                  </div>
                  <div className="text-center bg-[grey] rounded-full w-[40px] h-[40px]">
                    {/* <h1 className="text-3xl">3+</h1>
                    <p className="text-sm">Years</p> */}
                    <img
                      src={node}
                      className="w-[30px] h-[30px] m-auto"
                      width="100px"
                      height="100px"
                    />
                    <p className="text-md my-2">NodeJS</p>
                  </div>
                  <div className="text-center bg-[grey] rounded-full w-[40px] h-[40px]">
                    {/* <h1 className="text-3xl">3+</h1>
                    <p className="text-sm">Years</p> */}
                    <img
                      src={ts}
                      className="w-[30px] h-[30px] m-auto"
                      width="100px"
                      height="100px"
                    />
                    <p className="text-md my-2">TypeScript</p>
                  </div>
                  <div className="text-center bg-[grey] rounded-full w-[40px] h-[40px]">
                    {/* <h1 className="text-3xl">3+</h1>
                    <p className="text-sm">Years</p> */}
                    <img
                      src={JS}
                      className="w-[30px] h-[30px] m-auto"
                      width="100px"
                      height="100px"
                    />

                    <p className="text-md my-2">JavaScript</p>
                  </div>
                  <div className="text-center bg-[grey] rounded-full w-[40px] h-[40px]">
                    {/* <h1 className="text-3xl">3+</h1>
                    <p className="text-sm">Years</p> */}
                    <img
                      src={tailwind}
                      className="w-[30px] h-[30px] m-auto"
                      width="100px"
                      height="100px"
                    />

                    <p className="text-md my-2">Tailwind CSS</p>
                  </div>
                  {/* <div className="text-center ">
                    <h1 className="text-3xl">10+</h1>
                    <p className="text-sm">Case studies & Articles</p>
                  </div>
                  <div className="text-center ">
                    <h1 className="text-3xl">12+</h1>
                    <p className="text-sm">Projects</p>
                  </div> */}
                </div>
                <div className="flex flex-wrap justify-center w-full px-5 lg:mx-0 fontN">
                  <a
                    href="https://github.com/Aladefaruk"
                    target="_blank"
                    rel="noreferrer"
                    className="py-3 my-3 lg:m-2 w-full lg:w-2/5  text-white bg-white rounded-lg cursr-pointer dark-blue"
                  >
                    View My GitHub
                  </a>
                  <a
                    href="https://www.linkedin.com/in/farukalade/"
                    target="_blank"
                    rel="noreferrer"
                    className="py-3 my-3 lg:m-2 w-full lg:w-2/5 rounded-lg ldark-blue lg:mx-14 cursor-pointer"
                    style={{ background: "#023ED4" }}
                  >
                    View My LinkedIn
                  </a>
                </div>
              </div>
            )}
          </Spring>
        )}
      </VisibilitySensor>
    </div>
  );
};

export default Summary;
